import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[560px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20modern%20minimalist%20digital%20workspace%20with%20abstract%20gradient%20shapes%2C%20soft%20beige%20and%20cream%20background%20with%20geometric%20patterns%2C%20warm%20golden%20accents%2C%20clean%20Asian%20aesthetic%2C%20light%20airy%20atmosphere%2C%20abstract%20composition%2C%20professional%20feel%2C%20soft%20diffused%20lighting&width=1600&height=900&seq=hero-bg-main&orientation=landscape"
          alt="亚洲免费在线资源汇总平台"
          className="w-full h-full object-cover object-top"
          title="亚洲免费在线资源汇总平台"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>
      </div>
      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 text-background-50 text-sm mb-6">
          <i className="ri-sparkling-2-line"></i>
          <span>探索亚洲优质免费在线资源</span>
        </div>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 font-heading leading-tight mb-5">
          亚洲免费在线
          <span className="block text-xl md:text-2xl lg:text-3xl font-normal mt-2 opacity-90">
            资源汇总平台
          </span>
        </h1>
        <p className="text-base md:text-lg text-background-200 max-w-2xl mx-auto mb-8 leading-relaxed">
          汇集亚洲各国优质免费在线内容、工具与服务 — 无需付费，即可畅享精选资源
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/ai-tools"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-lg font-medium hover:bg-primary-600 transition-all hover:scale-105 whitespace-nowrap"
          >
            探索热门资源
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <Link
            to="/about"
            className="px-6 py-3 bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-lg font-medium hover:bg-background-50/25 transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>
        <div className="mt-10 flex items-center justify-center gap-8">
          {[
            { num: '200+', label: '精选资源' },
            { num: '8', label: '分类覆盖' },
            { num: '50K+', label: '月度访客' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-background-50 font-heading">{stat.num}</div>
              <div className="text-xs text-background-300 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}